module["exports"] = [
  "5[1-5]##-####-####-###L",
  "6771-89##-####-###L"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/finance/credit_card/mastercard.js
// module id = 2646
// module chunks = 1610